<div class="modal-header">
  <h5 class="modal-title">
    {{ faqId ? 'კითხვის/პასუხის რედაქტირება' : 'კითხვის/პასუხის დამატება' }}
  </h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <app-spinner [loading]="loading" text="იტვირთება..."></app-spinner>

  <form [formGroup]="form" *ngIf="!loading">
    <div class="row g-3">

      <!-- Page select -->
      <div class="col-12">
        <div class="form-floating">
          <select class="form-select" formControlName="menu_page" id="menuPage">
            <option [ngValue]="null" disabled>აირჩიე FAQ გვერდი...</option>
            <option *ngFor="let p of pages" [ngValue]="p.menu_page">
              {{ p.title }} ({{ p.menu_page }})
            </option>
          </select>
          <label for="menuPage">FAQ გვერდი (menu_page)</label>
        </div>

        <div class="invalid-feedback d-block" *ngIf="f['menu_page'].touched && f['menu_page'].invalid">
          გთხოვ აირჩიო გვერდი
        </div>

        <div class="hint small text-muted mt-1" *ngIf="form.value.menu_page">
          არჩეული: <b>{{ form.value.menu_page }}</b>
        </div>
      </div>

      <!-- Question -->
      <div class="col-12">
        <div class="form-floating">
          <input
            id="question"
            type="text"
            class="form-control"
            placeholder="კითხვა"
            formControlName="question"
          />
          <label for="question">კითხვა</label>
        </div>

        <div class="invalid-feedback d-block" *ngIf="f['question'].touched && f['question'].invalid">
          კითხვა სავალდებულოა
        </div>
      </div>

      <!-- Answer -->
      <div class="col-12">
        <div class="form-floating">
          <textarea
            id="answer"
            class="form-control"
            placeholder="პასუხი"
            formControlName="answer"
            style="min-height: 180px;"
          ></textarea>
          <label for="answer">პასუხი</label>
        </div>

        <div class="invalid-feedback d-block" *ngIf="f['answer'].touched && f['answer'].invalid">
          პასუხი სავალდებულოა
        </div>
      </div>

      <!-- Visible -->
      <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" formControlName="visible" id="visible">
            <option [ngValue]="1">ჩანს</option>
            <option [ngValue]="0">არ ჩანს</option>
          </select>
          <label for="visible">გამოჩენა</label>
        </div>
      </div>

    </div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
        გაუქმება
      </button>

      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
        <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
        შენახვა
      </button>
    </div>
  </form>
</div>